import React from "react";
import "./EmployeeExperience.css";
import {
  FaUserTie,
  FaBriefcase,
  FaBuilding,
  FaHandshake,
} from "react-icons/fa";
import { redirect } from "react-router-dom";

const data = [
  {
    icon: <FaUserTie />,
    title: "Professional Recruitment",
    percentage: "100%",
    text: "We specialize in sourcing and recruiting top-tier talent across various industries, ensuring the right fit for your organization’s needs.",
  },
  {
    icon: <FaBriefcase />,
    title: "Job Placement Services",
    percentage: "100%",
    text: "Connecting job seekers with the best opportunities to help them build successful careers in their respective fields.",
  },
  {
    icon: <FaBuilding />,
    title: "Corporate Hiring Solutions",
    percentage: "100%",
    text: "Offering tailored hiring solutions for businesses, including bulk hiring, executive search, and contract staffing.",
  },

  {
    icon: <FaHandshake />,
    title: "HR Consulting & Support",
    percentage: "100%",
    text: "Comprehensive HR solutions, including employee engagement, compliance, and performance management support.",
  },
];

const EmployeeExperience = () => {
  return (
    <section className="EmployeeExperience container-fluid py-5">
      <div className="container">
        <h4 className="EmployeeExperience-tag">About Our Services ⏵</h4>
        <h2 className="EmployeeExperience-title">
          Strategies To Enhance <br /> Engagement And Well-Being
        </h2>

        <div className="row">
          {data.map((item, index) => (
            <div key={index} className="col-md-3 col-sm-6 text-center">
              <div
                className="EmployeeExperience-icon"
                style={{ fontSize: "50px", color: "#0D47A0" }}
              >
                {item.icon}
              </div>
              <h5 className="EmployeeExperience-heading">{item.title}</h5>
              <hr className="EmployeeExperience-divider" />
              <h2 className="EmployeeExperience-percentage">
                {item.percentage}
              </h2>
              <p className="EmployeeExperience-text">{item.text}</p>
            </div>
          ))}
        </div>

        <div className="EmployeeExperience-btn-container text-end">
          <a href="aboutus">
            <button className="EmployeeExperience-btn">
              KNOW MORE <span className="arrow">⏵</span>
            </button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default EmployeeExperience;
